import React from "react";
import { Outlet } from "react-router-dom";
import EligibilityHeader from "./components/EligibilityHeader";

function index(props) {
  return (
    <>
      <Outlet />
    </>
  );
}

export default index;
